import helpers from '@/helpers/helpers';
export default {
  modelName: 'act_idtf_assignment',
  versionModelName: 'act_version',
  label: '法規鑑別列表',
  fields: {
    query: {
      type: 'custom',
      getValue: function(item){
        if (!item.act_version || !item.act_version.act) return null
        return `?act=${item.act_version.act.id}`
      }
    },
    name: {
      label: '法規名稱',
      type: 'text',
      width: '300px',
      isValueComparable: true,
    },
    act_version: {
      label: '法規名稱',
      type: 'belongsTo',
      width: '300px',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    short_name: {
      type: 'text',
      label: '法規簡稱',
      textKey: 'short_name',
      maxlength: 50,
      isValueComparable: true,
    },
    act_comment: {
      type: 'textarea',
      label: '立法總說明',
      textKey: 'act_comment',
      maxlength: 10000,
      isValueComparable: true,
    },
    status: {
      type: 'textarea',
      label: '施行狀態',
      textKey: 'status',
      maxlength: 10000,
      isValueComparable: true,
    },
    ll_comment: {
      type: 'textarea',
      label: 'ESGoal總評',
      textKey: 'll_comment',
      maxlength: 10000,
      isValueUpdatable: true,
      isValueComparable: true,
    },
    reference_link: {
      type: 'link',
      label: '來源連結',
      textKey: 'reference_link',
      maxlength: 500,
      isValueComparable: true,
    },
    attaches: {
      type: 'files',
      label: '法規附件',
      textKey: 'attaches',
      uploadUrl: '/act_version/attach/',
      isValueComparable: true,
    },
    announce_at: {
      type: 'date',
      label: '修正發布日',
      isValueComparable: true,
    },
    effect_at: {
      type: 'date',
      label: '生效日期',
      rules: 'required',
      isValueComparable: true,
    },
    areas: {
      label: '適用地區',
      type: 'multi-layer',
      rules: 'required',
      modelName: 'areas',
      getUrl: 'area',
      requiredField: 'area_sections',
      multiple: true,
      layersSetting: {
        modelName: 'area_sections',
        requiredFieldKey: 'area_sections',
        search: true,
      },
      getText: (data) => {
        if (!Array.isArray(data)) return
        let result = ''
        data.forEach((_data) => {
          if (result !== '') {
            result += ','
          }
          result += _data.name
        })
        return result
      },
      fields: {
        modelName: 'area',
        requiredField: 'area_sections',
        layersSetting: {
          modelName: 'area_sections',
          requiredFieldKey: 'area_sections',
          search: true,
        },
      }
    },
    no_text: {
      label: '鑑別項目',
      type: 'text',
      width: '300px',
    },
    icon: {
      label: '更新版本',
      type: 'custom',
      readonly: true,
      getValue: function(item){
        if (!item || !item.last_version) return null;
        return (!item.last_second_version || item.last_version.id !== item.last_second_version.id) ? 'mdi-check' : null;
      }
    },
    act_cnt_status: {
      type: 'text',
      label: '格式更新狀態',
      readonly: true,
      textKey: 'name',
      getText: function (value){
        switch (value) {
          case 1:
            return '更新中'
          case 2:
            return '覆核中'
          case 3:
            return '完成'
          case null:
            return '-'
        }
      }
    },
    idtf_status: {
      type: 'text',
      label: '鑑別狀態',
      readonly: true,
      textKey: 'name',
      getText: function (value){
        switch (value) {
          case 1:
            return '鑑別中'
          case 2:
            return '覆核中'
          case 3:
            return '完成'
          case null:
            return null;
        }
      }
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後編輯者',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    updated_at: {
      type: 'datetime',
      label: '最後編輯時間',
      readonly: true,
    },
    created_at: {
      type: 'datetime',
      label: '建立時間',
      readonly: true,
    },
    created_admin: {
      type: 'belongsTo',
      label: '建立者',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    last_version: {
      type: 'last_version',
      label: '版本列表',
      modelName: 'act_version',
      showFields: ['title_mainlocale', 'updated_at'],
      fields: {
        locales: {
          type: 'locales',
          fields: {
            name: {
              type: 'text',
              label: '法規名稱',
              width: '300px',
              rules: 'required',
              maxlength: 100,
            },
            short_name: {
              type: 'text',
              label: '法規簡稱',
              maxlength: 50,
            },
            act_comment: {
              type: 'textarea',
              label: '立法總說明',
              maxlength: 10000,
            },
            status: {
              type: 'textarea',
              label: '施行狀態',
              maxlength: 10000,
            },
            ll_comment: {
              type: 'textarea',
              label: 'ESGoal總評',
              maxlength: 10000,
            },
          },
        },
        reference_link: {
          type: 'link',
          label: '來源連結',
          maxlength: 500,
        },
        attaches: {
          type: 'files',
          label: '法規附件',
          uploadUrl: '/act_version/attach/',
        },
        released_admin: {
          type: 'belongsTo',
          label: '發布人員',
          readonly: true,
          textKey: 'name',
          modeldataName: 'admin',
        },
        released_at: {
          type: 'datetime',
          label: '發布時間',
          readonly: true,
        },
      },
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    area_sections: {
      label: '適用子地區',
      type: 'hasMany',
      hide: true,
      getText: (data) => {
        return data.name;
      },
    },
    act_type: {
      label: '法律類型',
      type: 'belongsTo',
      textKey: 'name',
      modelName: 'act_type',
      requiredField: 'area',
      rules: 'required',
      width: '150px',
      conditionKeys: [
        {
          fieldName: 'area',
          conditionName: 'area',
        },
      ],
    },
    industry_categories: {
      label: '適用產業類別',
      type: 'multi-layer',
      modelName: 'industry_categories',
      getUrl: 'industry_category',
      multiple: true,
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      fields: {
        modelName: 'industry_categories',
        getUrl: 'industry_category',
        conditionKeys: [
          {
            fieldName: 'areas',
            conditionName: 'area',
            type: 'array',
          },
        ],
      }
    },
    system_classes: {
      label: '領域',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'system_class',
      requiredField: 'area',
      width: '150px',
      rules: 'required',
      conditionKeys: [
        {
          fieldName: 'area',
          conditionName: 'area',
        },
      ],
    },
    system_subclasses: {
      conditionKeys: [
        {
          fieldName: 'system_classes',
          conditionName: 'system_class',
          type: 'array',
        },
      ],
      requiredField: 'system_classes',
      label: '子領域',
      type: 'hasMany',
      rules: 'required',
      textKey: 'name',
      width: '150px',
      modelName: 'system_subclass',
    },
    range_type: {
      type: 'select',
      label: '適用範圍類型',
      items: [
        {
          value: 'general',
          text: '通用',
        },
        {
          value: 'exclusive',
          text: '專屬',
        },
      ],
      defaultValue: 'general',
    },
    factories: {
      type: 'hasMany',
      label: '適用工廠',
      textKey: 'name',
      modelName: 'factory',
      requiredField: 'area',
      conditionKeys: [
        {
          fieldName: 'area',
          conditionName: 'area',
          type: 'array',
        },
      ],
      getText: (item) => {
        return helpers.methods.$_CMS_getFactoryName(item)
      },
      displayCheck: (modelData) => {
        if (modelData.range_type === 'general') {
          return true
        } else if(modelData.range_type === 'exclusive') {
          return false
        }
      },
    },
    exclusive_factories: {
      type: 'hasMany',
      label: '專屬工廠',
      textKey: 'name',
      modelName: 'factory',
      requiredField: 'area',
      conditionKeys: [
        {
          fieldName: 'area',
          conditionName: 'area',
          type: 'array',
        },
      ],
      getText: (item) => {
        return helpers.methods.$_CMS_getFactoryName(item)
      },
      displayCheck: (modelData) => {
        if (modelData.range_type === 'general') {
          return false
        } else if(modelData.range_type === 'exclusive') {
          return true
        }
      },
    },
    act_cnt_updated_at: {
      type: 'datetime',
      label: '格式更新編輯時間',
      readonly: true,
    },
    act_cnt_updated_admin: {
      type: 'belongsTo',
      label: '格式更新編輯者',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    act_cnt_final_reviewed_at: {
      type: 'datetime',
      label: '格式更新覆核編輯時間',
      readonly: true,
    },
    act_cnt_final_reviewer: {
      type: 'belongsTo',
      label: '格式更新覆核編輯者',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    idtf_updated_at: {
      type: 'datetime',
      label: '鑑別編輯時間',
      readonly: true,
    },
    idtf_updated_admin: {
      type: 'belongsTo',
      label: '鑑別編輯者',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    idtf_final_reviewed_at: {
      type: 'datetime',
      label: '鑑別覆核編輯時間',
      readonly: true,
    },
    idtf_final_reviewer: {
      type: 'belongsTo',
      label: '鑑別覆核編輯者',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    overall_owners: {
      label: '鑑別作業總負責人',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'admin',
      rules: 'required',
      width: '150px',
      clearable: true,
      conditionKeys: [
        {
          fieldName: 'is_active',
          conditionName: 'is_active',
        },
      ],
    },
    km_owners: {
      label: 'KM負責人',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'admin',
      rules: 'required',
      width: '150px',
      clearable: true,
      conditionKeys: [
        {
          fieldName: 'is_active',
          conditionName: 'is_active',
        },
      ],
    },
    km_backups: {
      label: 'KM備員',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'admin',
      rules: 'required',
      width: '150px',
      clearable: true,
      conditionKeys: [
        {
          fieldName: 'is_active',
          conditionName: 'is_active',
        },
      ],
    },
    km_reviewers: {
      label: 'KM覆核人',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'admin',
      rules: 'required',
      width: '150px',
      clearable: true,
      conditionKeys: [
        {
          fieldName: 'is_active',
          conditionName: 'is_active',
        },
      ],
    },
    idtf_owners: {
      label: '鑑別負責人',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'admin',
      rules: 'required',
      width: '150px',
      clearable: true,
      conditionKeys: [
        {
          fieldName: 'is_active',
          conditionName: 'is_active',
        },
      ],
    },
    idtf_backups: {
      label: '鑑別備員',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'admin',
      rules: 'required',
      width: '150px',
      clearable: true,
      conditionKeys: [
        {
          fieldName: 'is_active',
          conditionName: 'is_active',
        },
      ],
    },
    idtf_reviewers: {
      label: '鑑別覆核人',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'admin',
      rules: 'required',
      width: '150px',
      clearable: true,
      conditionKeys: [
        {
          fieldName: 'is_active',
          conditionName: 'is_active',
        },
      ],
    },
    overall_review_updated_at: {
      type: 'datetime',
      label: '總覆核編輯時間',
      readonly: true,
    },
    overall_review_updated_admin: {
      type: 'belongsTo',
      label: '總覆核編輯者',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '法規名稱',
          width: '300px',
          rules: 'required',
          maxlength: 100,
        },
        short_name: {
          type: 'text',
          label: '法規簡稱',
          maxlength: 50,
        },
        act_comment: {
          type: 'textarea',
          label: '立法總說明',
          maxlength: 10000,
        },
        status: {
          type: 'textarea',
          label: '施行狀態',
          maxlength: 10000,
        },
        ll_comment: {
          type: 'textarea',
          label: 'ESGoal總評',
          maxlength: 10000,
        },
      },
    },
    act_cnt_check_result: {
      type: 'text',
      label: '格式更新結果',
      readonly: true,
      getText: function(text){
        let resultText = text === '-'
          ? '-'
          : text == '0'
          ? '不通過'
          : text == '1'
          ? '通過'
          : '-';
        return resultText;
      },
      customCheckAction: function(item, value) {
        item.act_cnt_check_result = value == 1
        ? '通過'
        : '不通過'
      }
    },
    act_cnt_review_result: {
      type: 'text',
      label: '格式更新覆核結果',
      readonly: true,
      getText: function(text){
        let resultText = text === '-'
          ? '-'
          : text == '0'
          ? '不通過'
          : text == '1'
          ? '通過'
          : '-';
        return resultText;
      }
    },
    act_cnt_final_review_remark: {
      type: 'textarea',
      label: '格式更新覆核備註',
      textKey: 'act_cnt_final_review_remark',
      maxlength: 1000,
    },
    idtf_check_result: {
      type: 'text',
      label: '鑑別結果',
      readonly: true,
      getText: function(text){
        let resultText = text === '-'
          ? '-'
          : text == '0'
          ? '不通過'
          : text == '1'
          ? '通過'
          : '-';
        return resultText;
      },
      customCheckAction: function(item, value) {
        item.idtf_check_result = value == 1
        ? '通過'
        : '不通過'
      }
    },
    idtf_review_result: {
      type: 'text',
      label: '鑑別覆核結果',
      getText: function(text){
        let resultText = text === '-'
          ? '-'
          : text == '0'
          ? '不通過'
          : text == '1'
          ? '通過'
          : '-';
        return resultText;
      }
    },
    idtf_final_review_remark: {
      type: 'textarea',
      label: '鑑別覆核備註',
      maxlength: 1000,
    },
    overall_review_result: {
      type: 'text',
      label: '總覆核結果',
      getText: function(text){
        let resultText = text === '-'
          ? '-'
          : text == '0'
          ? '不通過'
          : text == '1'
          ? '通過'
          : '-';
        return resultText;
      },
      customCheckAction: function(item, value) {
        item.overall_review_result = value == 1
        ? '通過'
        : '不通過'
      }
    },
    overall_review_remark: {
      type: 'textarea',
      label: '總覆核備註',
      maxlength: 1000,
    },
    btnLoading: {
      readonly: true,
      getText: () => false,
    },
    dot: {
      readonly: true,
    },
    overall_review_status: {
      type: 'text',
      label: '總覆核狀態',
      readonly: true,
      textKey: 'name',
      getText: (value) =>{
        switch (value) {
          case 1:
            return '覆核中';
          case 2:
            return '完成';
          case null:
            return null;
        }
      }
    },
    has_released_first: {
      type: 'switch',
      label: '格式內容覆核完成後是否發布',
      defaultValue: true,
      activeText: '是',
      inactiveText: '否',
    },
    has_idtf: {
      type: 'switch',
      label: '是否需要律師鑑別',
      defaultValue: true,
      activeText: '是',
      inactiveText: '否',
    },
    idtf_overall_reviewed_at: {
      type: 'datetime',
      label: '總覆核編輯時間',
      readonly: true,
    },
    idtf_overall_reviewer: {
      type: 'belongsTo',
      label: '總覆核編輯者',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    idtf_remark: {
      type: 'textarea',
      label: '鑑別備註',
      maxlength: 1000,
    },
  },
};
